module.exports = __webpack_public_path__ + "img/gruppo-mail-alertduedate.1478561a.png";